<template>
<div class="row vertical-10p">
  <div class="container">
    <img src="/static/img/logo.png" alt="LeadScorz" title="LeadScorz" class="center-block logo"> 
    <div class="text-center col-md-4 col-sm-offset-4">
      <form class="ui form loginForm" method="POST" v-on:submit.prevent="onSubmit">
        <div v-if="error" class="aler alert-danger">An unexepected error happened, please try again later.</div>
        <div v-else-if="ok" class="alert alert-success" role="alert">Thank you! Your email has been confirmed.</div>
        <div v-else class="alert alert-info" role="alert">Please click the "Confirm email" button to verify your email address.</div>
        
        <button v-show="!ok && !error" type="submit" class="btn btn-block btn-primary btn-lg">Confirm Email</button>
      </form>
      <div>
        <router-link to="/login">Go back to Sign In</router-link>
      </div>      
    </div>
  </div>
</div>
</template>

<script>
export default {
  data: function () {
    return {
      ok: false,
      error: false
    };
  },
  methods: {
    onSubmit: function () {
      var self = this;
      let key = this.$route.params.key;
      self.ok = false;
      self.error = false;
      API.user.confirmEmail(key)
        .then(() => { self.ok = true },
              () => { self.error = true })
        .catch(() => { self.error = true });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html, body, .container-table {
  height: 100%;
  background-color: #eee;
}
.container-table {
  display: table;
  color: white;
}
.vertical-center-row {
  display: table-cell;
  vertical-align: middle;
}

.form {
  background: #fff;
  padding: 35px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08);
  font-size: 1.1em;
  margin-bottom: 30px;
}

.vertical-20p {
  padding-top: 20%;
}
.vertical-10p {
  padding-top: 10%;
}
.loginForm .input-group {
  padding-bottom: 1em;
  height: 4em;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}
.input-group input {
  height: 3em;
  color: #002754 !important;
  font-size: 1.1em;
}

.input-group .input-group-addon {
  border-radius: 0;
  width: 37px;
}
.text-red {
  color: red !important;
}

.btn-primary {
  margin-top: 30px;
  border: 1px solid #ff4d50;
  color: #ff4d50;
  background: #fff;
}

.btn-primary:hover, .btn-primary:focus {
  color: #fff;
  background: #ff4d50;
}
</style>



// WEBPACK FOOTER //
// ConfirmEmail.vue?244eff94